import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  SubHeaderStyled,
  BodyStyled,
  ButtonWrapperStyled,
} from './styles/ProcessingStyled';
import { ReactComponent as SuccessIcon } from '../../../../images/ui/success-big.svg';
import { GoogleTagManager } from '../../../../helpers';

const Success = ({ buttonHandler }) => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/marketplace/categorias/bolsas/contrasaldo',
      pagename: 'COMPRA_BOLSA_CONVERSION_CONTRASALDO',
    });
  }, []);

  return (
    <ContainerStyled>
      <HeaderStyled>Tu bolsa ha sido comprada</HeaderStyled>
      <SubHeaderStyled>En los próximos minutos estará visible</SubHeaderStyled>
      <SuccessIcon />
      <BodyStyled>
        <p>¡Muchas gracias!</p>
        <p>Ahora disfruta de tu compra!</p>
      </BodyStyled>
      <ButtonWrapperStyled>
        <Button
          color="bubbleGum"
          width="300px"
          maxWidth="300px"
          click={buttonHandler}
        >
          VOLVER AL INICIO
        </Button>
      </ButtonWrapperStyled>
    </ContainerStyled>
  );
};

Success.propTypes = {
  buttonHandler: PropTypes.func.isRequired,
};

export default Success;
